module.exports = __webpack_public_path__ + "44367bd3887e65e760234c6d9d679d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/pricing2.png
// module id = 709
// module chunks = 0